import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const OnboardingFooterContext = createContext(null);

export function OnboardingFooterProvider({ value, children }) {
  return <OnboardingFooterContext.Provider value={value}>{children}</OnboardingFooterContext.Provider>;
}

OnboardingFooterProvider.propTypes = {
  value: PropTypes.shape({
    setFooterConfig: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export function useOnboardingFooter() {
  const context = useContext(OnboardingFooterContext);
  if (!context) {
    return () => {};
  }
  return context.setFooterConfig;
}
